export default __webpack_public_path__ + "static/media/9_tec-soft.102cd017.svg";